/* 🤖 this file was generated by svg-to-ts */
export const matIconDomainVerification: {
  name: 'domain-verification';
  data: string;
} = {
  name: 'domain-verification',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m16.6 10.88-1.42-1.42-4.24 4.25-2.12-2.13L7.4 13l3.54 3.54z"/><path d="M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6a2 2 0 0 0-2-2zm0 14H5V8h14v10z"/></svg>`
};
